import React, { useContext } from 'react';
import { ModalHeader, ModalBody, ModalFooter, Typography, Button, } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Alert } from '../../shared/alert/alert';
import { GiftCardLogoAndNumber } from '../gift-card/logo-number';
export const DisplayGiftCardBalance = ({ card, balance, hideModal, errorMessage = false, }) => {
    const { channel } = useContext(ExperienceContext);
    const isMobile = channel === 'mobile';
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Check Gift Card Balance"),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "sui-grid sui-flex-col sui-gap-y-6 " }, errorMessage ? (React.createElement(Alert, { status: "error" }, errorMessage)) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-flex sui-flex-wrap" },
                    React.createElement(GiftCardLogoAndNumber, { card: card, shouldShowInactive: true })),
                React.createElement(Typography, { variant: "body-base" },
                    "Current Balance:",
                    ' ',
                    React.createElement(Typography, { variant: "body-base", weight: "bold", component: "span" },
                        "$",
                        balance)))))),
        React.createElement(ModalFooter, { position: isMobile ? 'center' : 'end' },
            React.createElement("div", { className: "sui-flex sui-p-2 sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "primary", onClick: hideModal }, "Close")))));
};
